import { all, fork, put, takeEvery } from 'redux-saga/effects';
import callToAPI from '../../../utils/callToAPI';
import * as Api from '../../api/cemexTracking';
import * as types from './types';
import {
  CemexTrackingOrder,
  CemexTrackingTicket,
} from '../../../models/CemexTrackingOrder';

function* getOrders({ payload }) {
  yield callToAPI({
    apiCall: Api.getCemexTrackingOrders,
    successResponseCode: 200,
    errorType: types.GET_CEMEX_TRACKING_ORDERS_ERROR,
    *callback({ data: { orders } }) {
      yield put({
        type: types.GET_CEMEX_TRACKING_ORDERS_SUCCESS,
        payload: {
          data: orders.map(
            (item) =>
              new CemexTrackingOrder({
                ...item,
                tickets: item.tickets?.map(
                  (ticket) => new CemexTrackingTicket({ ...ticket }),
                ),
              }),
          ),
          total: orders.length,
        },
      });
    },
    payload,
  });
}

function* watcherGetOrders() {
  yield takeEvery(types.GET_CEMEX_TRACKING_ORDERS_REQUEST, getOrders);
}

export default function* rootSaga() {
  yield all([fork(watcherGetOrders)]);
}
